import axios from "axios";

export const GET_LIST_BLOG = "GET_LIST_BLOG";
export const GET_ID_BLOG = "GET_ID_BLOG";

const linkapi = "https://server-mpustaka.herokuapp.com/";
// const linklocal = "http://localhost:3006/";

export const getListBlog = () => {
    return (dispatch) => {
        //loading
        dispatch({
            type: GET_LIST_BLOG,
            payload: {
                loading: true,
                data: false,
                errorMessage: false,
            },
        });
        //get API end-point
        axios
            .get(linkapi + `blog?_sort=createAt&_order=desc`)
            .then((response) => {
                dispatch({
                    type: GET_LIST_BLOG,
                    payload: {
                        loading: false,
                        data: response.data,
                        errorMessage: false,
                    },
                });
            })
            .catch((error) => {
                dispatch({
                    type: GET_LIST_BLOG,
                    payload: {
                        loading: false,
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });
    };
};

export const getIdBlog = (data) => {
    return (dispatch) => {
        //loading
        dispatch({
            type: GET_ID_BLOG,
            payload: {
                loading: true,
                data: data,
                errorMessage: false,
            },
        });
    };
};
